import { Component, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { SectionDescriptionComponent } from '../section-description/section-description.component';
import { SafeHtmlPipe } from '../../../pipes/safe-html.pipe';
import { AddSvgComponent } from '../../../../../public/images/add-svg.component';
import { arrowDownSVG } from '../../../constants/svg/arrow-down';
import { arrowUpSVG } from '../../../constants/svg/arrow-up';
import { MinusSvgComponent } from '../../../../../public/images/minus-svg.component';

@Component({
  selector: 'app-faq-accordion',
  standalone: true,
  imports: [
    MatExpansionModule,
    MatIconModule,
    SectionDescriptionComponent,
    SafeHtmlPipe,
    AddSvgComponent,
    MinusSvgComponent,
  ],
  templateUrl: './faq-accordion.component.html',
  styleUrl: './faq-accordion.component.scss',
})
export class FaqAccordionComponent {
  @Input({ required: true }) faqQuestion!: string;
  @Input({ required: true }) faqAnswer!: string;

  @Input({ required: true }) faqId!: number;
  @Input({ required: true }) faqIsExpanded!: boolean;
  @Input() showArrow: boolean = false;

  arrowDownSVG = arrowDownSVG;
  arrowUpSVG = arrowUpSVG;

  toggleComponent(id: number) {
    // Toggle the `show` value for the clicked item and reset others
    this.faqIsExpanded = this.faqId === id && !this.faqIsExpanded;
  }
}
